const INITIAL_STATE = {
    totalPrice: 0,
    currencySymbol: "",
    nrExcursions: 0,
    excursions: {},
    tac: {},
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'SET_BOOKINGS':
            return {
                totalPrice: action.bookings.totalPrice,
                currencySymbol: action.bookings.currencySymbol,
                nrExcursions: action.bookings.nrExcursions,
                excursions: action.bookings.excursions,
                tac: action.bookings.tacEntries,
            };

        case 'CLEAR_BOOKINGS':
            return INITIAL_STATE;

        default:
            return state;
    }
}
